import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';

export function relatedObjectsReducer(state = initialstate.relatedObjects, action) {
	switch (action.type) {
		case types.GET_RELATED_OBJECTS: {
			if (action.response) {
				if (action.documentEntityId && action.entityUId && action.entityId) {
					// let newState = _.cloneDeep(state);
					// const parentObject = findParentObject(newState.data, {
					// 	entityId: action.entityId,
					// 	entityUId: action.entityUId
					// });
					// if (parentObject) {
					// 	parentObject.children = action.response.data.map((child) => {
					// 		return { ...child, parentEntityName: parentObject.name };
					// 	});
					// }

					const data = normalize(action.response.data, state.data);

					const newState = {
						...state,
						data: {
							...data,
							[action.entityId]: {
								...data[action.entityId],
								byId: {
									...data[action.entityId].byId,
									[action.entityUId]: {
										...data[action.entityId].byId[action.entityUId],
										children: []
									}
								}
							}
						}
					};

					action.response.data.map((object) => {
						newState.data[action.entityId].byId[action.entityUId].children.push(object.id);
					});

					return newState || state;
				} else {
					const data = normalize(action.response.data, state.data);
					return {...action.response, data: data};
				}
			}
			break;
		}
		case types.DELETE_RELATED_OBJECTS: {
			if (!action.error) {
				if (!state.data?.[action.entityId]) {
					return state;
				}
				const newState = {
					...state,
					data: {
						...state.data,
						[action.entityId]: {
							allIds: state.data[action.entityId].allIds.filter((id) => {
								return id !== action.id;
							}),
							byId: {
								...state.data[action.entityId].byId
							}
						}
					}
				};

				delete newState.data[action.entityId].byId[action.id];

				return newState;
			}
			break;
		}
		case types.CREATE_RELATED_OBJECTS: {
			if (!action.error) {
				if (!_.isEmpty(state.data)) {
					return {
						...state,
						data: {
							...state.data,
							[action.entityId]: {
								...state.data[action.entityId],
								byId: {
									...state.data[action.entityId].byId,
									[action.response.entityUId]: {
										id: Number(action.response.entityUId),
										documentEntityId: state.documentEntityLevels.find((de) => {
											return de.entityId === action.meta.api.data.entityId;
										}).id,
										entityId: action.meta.api.data.entityId,
										name: action.name,
										entityUId: null,
										documentRelatedObjectId: action.response.id
									}
								},
								allIds: [...state.data[action.entityId].allIds, Number(action.response.entityUId)]
							}
						}
					};
				} else {
					return {
						documentEntityLevels: [
							{
								id: 1,
								entityId: action.response.entityId,
								parentDocumentEntityId: null
							}
						],
						data: {
							[action.entityId]: {
								byId: {
									[action.response.entityUId]: {
										id: Number(action.response.entityUId),
										documentEntityId: state.documentEntityLevels?.find((de) => {
											return de.entityId === action.meta.api.data.entityId;
										}).id,
										entityId: action.meta.api.data.entityId,
										name: action.name,
										entityUId: null,
										documentRelatedObjectId: action.response.id
									}
								},
								allIds: [Number(action.response.entityUId)]
							}
						}
					};
				}
			}
			break;
		}
		case types.UPDATE_RELATEOBJECTS_AFTER_RESPONSE: {
			if (action.response) {
				// let ro = findObject(newState.data, action.response);
				// if (ro) {
				// 	ro.name = action.response.entityName;
				// 	if (action.response.strategyTypeId) ro.additionalData.strategyTypeId = action.response.strategyTypeId;
				// }

				const updatedProperties = {
					name: action.response.entityName
				};
				const additionalData = {};

				if (action.response.strategyTypeId) {
					additionalData.strategyTypeId = action.response.strategyTypeId;
				}
				if (action.response.riskTypeId) {
					additionalData.riskTypeId = action.response.riskTypeId;
				}
				if (!_.isEmpty(state.data)) {
					return {
						...state,
						data: {
							...state.data,
							[action.response.entityId]: {
								...state.data[action.response.entityId],
								byId: {
									...state.data[action.response.entityId].byId,
									[action.response.id]: {
										...state.data[action.response.entityId].byId[action.response.id],
										...updatedProperties,
										additionalData: state.data[action.response.entityId].byId[action.response.id].additionalData
											? {
													...state.data[action.response.entityId].byId[action.response.id].additionalData,
													...additionalData
											  }
											: additionalData
									}
								}
							}
						}
					};
				}
			}
		}
		
		case types.GET_RELATED_OBJECTS_CONTROL: {
			if (action.response) {
				return {...action.response, data: action.response.data};
			}
			break;
		}

		default:
			return state;
	}
}

function normalize(field, accumulator, key) {
	let result;
	if (accumulator) {
		result = {...accumulator};
	}

	if (!result) {
		result = {};
	}

	// Run array normalization logic
	if (Array.isArray(field) && field.length > 0) {
		const addedById = {};
		const addedAllIds = [];
		let entity = {};

		for (let k = 0; k < field.length; k++) {
			entity = field[k];

			const index = key ? entity[key] : entity.id;

			if (!result[entity.entityId]) {
				result[entity.entityId] = {
					byId: {},
					allIds: []
				};
			}

			addedById[index] = entity;
			addedAllIds.push(index);
		}

		result = {
			...result,
			[entity.entityId]: {
				byId: {...result[entity.entityId].byId, ...addedById},
				allIds: _.uniq([...result[entity.entityId].allIds, ...addedAllIds])
			}
		};
	} else if (!Array.isArray(field) && !_.isEmpty(field)) {
		const index = key ? field[key] : field.id;
		result[field.entityId].byId[index] = field;
		result[field.entityId].allIds.push(index);
	}

	return result;
}
